/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_View_PlansInputs */



/**
* | output |
* | --- |
* | "View plans" |
*
* @param {Upgrade_View_PlansInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const upgrade_view_plans = /** @type {((inputs?: Upgrade_View_PlansInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_View_PlansInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voir les offres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tarife ansehen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vedi i piani")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Посмотреть тарифы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ver planes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("查看套餐")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プランを見る")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्लान देखें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ver planos")
	return /** @type {LocalizedString} */ ("View plans")
});